<template>
    <transition-group v-bind="$attrs" name="slide-from-top" v-on="$listeners">
        <slot />
    </transition-group>
</template>

<script>
export default {};
</script>

<style>
.slide-from-top-enter-active,
.slide-from-top-leave-active {
    transition: all 0.3s ease;
}
.slide-from-top-enter,
.slide-from-top-leave {
    opacity: 0;
    transform: translateY(-120%);
}
</style>
